import React from 'react'
import Box from '@material-ui/core/Box'
import clsx from 'clsx'
import { useStyles } from './styles'

const IconBadge = ({ icon: Icon, variant = 'detail' }) => {
  const classes = useStyles()

  return (
    <Box
      data-variant={variant}
      className={clsx(
        classes.iconBadge,
        variant === 'action'
          ? classes.actionIconBadge
          : classes.detailIconBadge,
      )}
    >
      <Icon />
    </Box>
  )
}

export default IconBadge
